<div class="part-container p-2">
    <div class="d-flex">
        <!--Status of the participant-->
        <div class="badge badge-pill mr-3 color-white font-weight-bold d-flex flex-column justify-content-center text-capitalize"
             [ngClass]="{
        'badge-primary': participant.status.toLowerCase() === 'accepted',
        'badge-warning': participant.status.toLowerCase() === 'owner',
        'badge-danger': participant.status.toLowerCase() === 'declined'
        }"
        >{{participant.status}}</div>
        <div class="my-auto">{{participant.name}}</div>
    </div>
    <!--Displaying all the participant's items-->
    <div *ngIf="items" class="d-flex flex-wrap justify-content-center w-50">
        <div *ngFor="let item of participantItems; let i = index" class="item-img" placement="top" ngbTooltip="{{getName(item.id)}}" [style.background-image]="'url('+getImage(item.id)+')'">
            <div (mouseover)="hovered = i" (mouseleave)="hovered = null" class="persons" [ngClass]="{
        'mouseover': hovered === i
        }">{{hovered === i ? item.persons : ''}}</div>
        </div>
    </div>
</div>
